/* MUI */
import { Typography } from '@mui/material';

/*  Shared  */
import { Token } from 'application/Shared/Requests';

/* Hooks */
import { getUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

/*  Components  */
import { IntegrationWrapper } from './Components/IntegrationWrapper';

/* Constants */
import IntegrationScriptFilename from './Constants/IntegrationScriptsFilename.json';

/* Helpers */
import { getScript } from './Helpers/utils';

class ATRMM extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deploymentSteps: [],
            hasToken: false
        };

        /* requests */
        this.Token = new Token();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const partnerToken = await this.Token.getToken();

        if (partnerToken) {
            this.setState({ hasToken: true });
            this.setDeploymentSteps(partnerToken);
        }
    };

    unload = () => {
        this.unmount = true;
        this.Token.cancel();
    };

    setDeploymentSteps = async (partnerToken) => {
        const { t } = this.props;

        let appVersion = '1.26.0';
        if (process.env.REACT_APP_VERSION) {
            appVersion = process.env.REACT_APP_VERSION;
        }

        const scriptCopyValue = await getScript({
            filename: IntegrationScriptFilename.atrmmScript,
            token: partnerToken
        });

        const deploymentSteps = [
            {
                component: (
                    <Typography variant="h4">
                        {t('Integrations.script_code')}
                    </Typography>
                ),
                step: false
            },
            {
                note: t('Integrations.note'),
                step: false
            },
            {
                component: t('Integrations.ATRMM.step1'),
                step: true
            },
            {
                component: t('Integrations.ATRMM.step2'),
                step: true
            },
            {
                component: t('Integrations.set_the_name'),
                copyValue: t('Integrations.asm_version', {
                    appVersion
                }),
                step: true
            },
            {
                component: t('Integrations.set_the_description'),
                copyValue: t('Integrations.ATRMM.step3_copyValue', {
                    date: new Date()
                }),
                step: true
            },
            {
                component: `${t('Integrations.set_the_level')}:`,
                step: true,
                stepValue: t('Integrations.ATRMM.step4_stepValue')
            },
            {
                component: `${t('Integrations.set_the_category')}:`,
                step: true,
                stepValue: t('Common.scripts')
            },
            {
                component: `${t('Integrations.set_the_scriptType')}:`,
                step: true,
                stepValue: t('Common.powershell')
            },
            {
                component: t('Integrations.ATRMM.step7'),
                copyValue: scriptCopyValue,
                step: true
            }
        ];

        if (!this.unmount) {
            this.setState({ deploymentSteps });
        }
    };

    render() {
        const { onboarding = false, session, t } = this.props;
        const { deploymentSteps, hasToken } = this.state;

        const userTheme = getUserTheme(session?.user?.theme);

        return (
            <IntegrationWrapper
                hasToken={hasToken}
                deploymentSteps={deploymentSteps}
                headerTitle={t('Integrations.ATRMM.header')}
                img={`/images/${userTheme}/integrations/at_rmm.png`}
                imgWidth="200px"
                onboarding={onboarding}
            />
        );
    }
}
export default withTranslation()(ATRMM);
